import React, { useEffect, useState } from "react";
import { Button, FormControl, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { loginThunk } from "../../../redux/thunks/auth.thunk";
import Joi from "joi";
import { IWithClassName } from "../../../theme/default.theme";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import AuthFrame from "../../../component/auth-frame";
import { TabEnum } from "../../../component/auth-frame/component";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const Login = ({ className }: IWithClassName) => {
  const { error: loginError } = useAppSelector((state) => state.auth.login);
  const schema = Joi.object({
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": "Email must be a valid email",
        "string.empty": "Email is required",
      }),
    password: Joi.string().min(8).max(20).required().messages({
      "string.min": "Password must be at least 8 characters",
      "string.max": "Password must be at most 20 characters",
      "string.empty": "Password is required",
    }),
  });

  useEffect(() => {
    setError((state) => ({
      ...state,
      email: loginError,
    }));
  }, [loginError]);

  const [loginFrom, setLoginForm] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState<{ email?: string; password?: string }>({});

  const dispatch = useAppDispatch();

  const onClick = () => {
    setError({});

    schema
      .validateAsync(loginFrom)
      .then((value) => dispatch(loginThunk(value)))
      .catch((err) => {
        setError((state) => ({
          ...state,
          [err.details[0].path[0]]: err.details[0].message,
        }));
      });
  };

  return (
    <AuthFrame tab={TabEnum.SING_IN}>
      <FormControl className={className}>
        <TextField
          id="email"
          placeholder="Email"
          label="E-mail"
          error={!!error.email}
          helperText={error.email}
          onChange={({ currentTarget }) =>
            setLoginForm((state) => ({
              ...state,
              email: currentTarget.value,
            }))
          }
          InputProps={{
            endAdornment: <MailOutlinedIcon />,
          }}
        />
        <TextField
          id="password"
          placeholder="Password"
          label="Password"
          error={!!error.password}
          helperText={error.password}
          type="password"
          onChange={({ currentTarget }) =>
            setLoginForm((state) => ({
              ...state,
              password: currentTarget.value,
            }))
          }
        />
        <Button
          variant="contained"
          onClick={onClick}
          startIcon={<ExitToAppIcon />}
        >
          Login
        </Button>
      </FormControl>
    </AuthFrame>
  );
};

export default Login;
